<template>
  <div v-if="isStatisticLoading" class="spinner-page">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div v-else class="statistics-page">
    <div class="main">
      <!-- Sidebar -->
      <div class="news-sidebar">
        <div class="filter-box sidebar-margin white-bg-box">
          <q-btn
            style="background: #25408f; color: white"
            label="Zoeken"
            @click="searchDashboard"
            dense
          >
            <i class="las la-search la-fw"></i>
          </q-btn>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
          <div class="row">
            <span style="width: fit-content" class="org-heading">Mijzelf</span>
            <i
              class="q-ml-sm las la-info-circle"
              style="margin-top: 12px;"
              
            >
              <q-tooltip class="q-ml-md">
                Gebruik het zoekveld Mijzelf om uw eigen organisatie als eerste
                te tonen bij de resultaten.
              </q-tooltip>
            </i>
            </div>
          <div class="row start orgs-select">
            <q-select
              dense
              outlined
              bg-color="white"
              v-model="selectedMainCustomer"
              :options="filterMainCustomerTags"
              option-value="label"
              class="budget-input"
              option-label="label"
              use-input
              input-debounce="800"
              behavior="menu"
              @filter="filterMainCustomerFn"
              clearable
              placeholder="Zoek een ontvanger "
              ref="mainCustomerSelect"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>

          <span class="org-heading">Ontvanger</span>
          <div class="row start orgs-select">
            <q-select
              dense
              outlined
              bg-color="white"
              v-model="selectedCustomers"
              multiple
              :options="filterCustomersTags"
              option-value="label"
              class="budget-input"
              option-label="label"
              placeholder="Zoek een ontvanger"
              use-input
              input-debounce="800"
              behavior="menu"
              use-chips
              @filter="filterCustomerFn"
              clearable
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>
        <div class="filter-box sidebar-margin orgs-box">
          <span class="org-heading">Verstrekker</span>
          <div class="row start orgs-select">
            <q-select
              dense
              outlined
              bg-color="white"
              v-model="selectedOrganisations"
              multiple
              :options="filterOrganisationsTags"
              option-value="label"
              class="budget-input"
              option-label="label"
              placeholder="Zoek een verstrekker"
              use-input
              input-debounce="0"
              behavior="menu"
              use-chips
              @filter="filterOrganisationsFn"
              clearable
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
          <span class="org-heading">Regeling</span>
          <div class="row start orgs-select">
            <q-select
              dense
              outlined
              bg-color="white"
              v-model="selectedSubjects"
              multiple
              :options="filterSubjectsTags"
              option-value="label"
              class="budget-input"
              option-label="label"
              placeholder="Zoek een regeling"
              use-input
              input-debounce="0"
              behavior="menu"
              use-chips
              @filter="filterSubjectsFn"
              clearable
              ref="select"
              @popup-show="width = $refs.select.$el.offsetWidth" 
              :popup-content-style="`width: ${width}px; word-break: break-all;`" 
              style="word-break: break-all;"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
          <span class="org-heading">Selecteer jaar</span>
          <div class="row start orgs-select">
            <q-select
              dense
              outlined
              bg-color="white"
              v-model="selectedYears"
              multiple
              :options="filterSelectedYears"
              option-value="label"
              class="budget-input"
              option-label="label"
              placeholder="Zoek een onderwerp"
              use-input
              input-debounce="0"
              behavior="menu"
              use-chips
              @filter="filterSelectedYearsFn"
              clearable
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>

        <div class="filter-box sidebar-margin orgs-box">
          <span class="org-heading">Selecteer scope</span>
          <div class="row start orgs-select">
            <q-select
              dense
              outlined
              bg-color="white"
              v-model="selectedScopes"
              multiple
              :options="scopesOptions"
              option-value="id"
              class="budget-input"
              option-label="name"
              placeholder="Select scope"
              input-debounce="0"
              behavior="menu"
              use-chips
              clearable
              label="Scope"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>

        <div class="filter-box sidebar-margin white-bg-box">
          <q-btn
            style="background: #25408f; color: white"
            label="Zoeken"
            @click="searchDashboard"
            dense
          >
            <i class="las la-search la-fw"></i>
          </q-btn>
        </div>

        <div class="filter-box sidebar-margin white-bg-box">
          <q-btn
            style="background: #25408f; color: white"
            label="Exporteren "
            @click="exportRecords"
            dense
          >
            <i class="las la-file-download la-fw"></i>
          </q-btn>
          <p
            class="q-mt-md text-dark text-weight-bolder"
            style="border: 1px solid black"
          >
            Disclaimer: We doen ons best zo volledig mogelijk te zijn, maar zijn
            afhankelijk van hetgeen de subsidieverstrekkers publiceren.
            Bijvoorbeeld Dienst Uitvoering Subsidies aan Instellingen (DUS-I) en
            Groningen verstrekken geen of onvolledige gegevens.
          </p>
        </div>
      </div>
      <div class="statistics-items">
        <div class="table-container">
          <q-card>
            <q-tabs
              v-model="tab"
              dense
              class="text-grey"
              active-color="primary"
              indicator-color="primary"
              align="left"
              narrow-indicator
            >
              <q-tab name="graphics" label="Grafiek"></q-tab>
              <q-tab name="statistics" label="Statistieken"></q-tab>
            </q-tabs>
            <q-separator></q-separator>
            <q-tab-panels v-model="tab" animated>
              <q-tab-panel name="graphics">
                <StatisticsChartTab />
              </q-tab-panel>
              <q-tab-panel name="statistics">
                <StatisticsTableTab />
              </q-tab-panel>
            </q-tab-panels>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import StatisticsChartTab from "../Statistics/StatisticsChartTab.vue";
import StatisticsTableTab from "../Statistics/StatisticsTableTab.vue";
import FiltersService from "../../services/filters.service";
import StatisticsUtils from "../../utils/statistics.js";
import store from "../../store/index.js";
/* import { array } from 'joi';
 */
export default {
  name: "StatisticsOverview",
  components: {
    StatisticsChartTab,
    StatisticsTableTab,
  },
  setup() {
    onMounted(() => {
      FiltersService.getDefaultFilters();
      StatisticsUtils.filterRecords();
      StatisticsUtils.customerCounts();
    });

    const tab = ref("graphics");
    const showTooltip = false;
    const isStatisticLoading = computed({
      get: () => store.state.statistics.isStatisticLoading,
    });
    //Customers
    const customerOptions = computed({
      get: () => store.state.fomoStatisticsSearch.customersOptions,
    });

    const customerOptionsOriginal = computed({
      get: () => store.state.fomoStatisticsSearch.customersOptions,
    });
    const mainCustomerOptions = computed({
      get: () => store.state.fomoStatisticsSearch.customersMainOptions,
    });
    const filterCustomersTags = ref(customerOptions.value);
    const selectedCustomers = computed({
      get: () => store.state.fomoStatisticsSearch.customersSelectArray,
      set: async (value) => {
        store.commit("fomoStatisticsSearch/updateSelectedCustomers", value);
      },
    });

    //Main customer
    const filterMainCustomerTags = ref(mainCustomerOptions.value);

    const selectedMainCustomer = computed({
      get: () => store.state.fomoStatisticsSearch.selectedMainCustomer,
      set: (val) => {
        store.commit("fomoStatisticsSearch/updateSelectedMainCustomer", val);
      },
    });
    watch(selectedCustomers, () => {
      if (selectedCustomers.value == null) {
        store.commit("fomoStatisticsSearch/updateSelectedCustomers", null);
      }
    });

    //Organisations
    const organisationsOptions = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsOptions,
    });
    const filterOrganisationsTags = ref(organisationsOptions.value);
    const selectedOrganisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
      set: async (value) => {
        store.commit("fomoStatisticsSearch/updateSelectedOrganisations", value);
      },
    });
    watch(selectedOrganisations, () => {
      if (selectedOrganisations.value == null) {
        store.commit("fomoStatisticsSearch/updateSelectedOrganisations", null);
      }
    });
    //Subjects
    const subjectsOptions = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsOptions,
    });
    const filterSubjectsTags = ref(subjectsOptions.value);
    const selectedSubjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
      set: async (value) => {
        store.commit("fomoStatisticsSearch/updateSelectedSubjects", value);
      },
    });
    watch(selectedSubjects, () => {
      if (selectedSubjects.value == null) {
        store.commit("fomoStatisticsSearch/updateSelectedSubjects", null);
      }
    });
    //Publish date
    const daysRangeModel = ref(null);
    const dateFrom = computed({
      get: () => store.state.fomoStatisticsSearch.daysRange.from,
    });
    const dateTo = computed({
      get: () => store.state.fomoStatisticsSearch.daysRange.to,
    });
    const days = computed({
      get: () => store.state.fomoStatisticsSearch.daysRange,
      set: (val) => {
        store.commit("fomoStatisticsSearch/updateDaysRange", val);
      },
    });
    const updateRange = () => {
      daysRangeModel.value = [dateFrom.value, dateTo.value].join(" - ");
    };
    const resetDate = () => {
      store.commit("fomoStatisticsSearch/updateDaysRange", {
        from: "",
        to: "",
      });
    };

    //Years picker
    const selectedYearsOptions = computed({
      get: () => store.state.fomoStatisticsSearch.yearsOptions,
    });
    const filterSelectedYears = ref(selectedYearsOptions.value);
    const selectedYears = computed({
      get: () => store.state.fomoStatisticsSearch.yearsSelectArray,
      set: async (value) => {
        store.commit("fomoStatisticsSearch/updateSelectedYears", value);
      },
    });
    watch(selectedYears, () => {
      if (selectedYears.value == null) {
        store.commit("fomoStatisticsSearch/updateSelectedYears", null);
      }
    });

    //Export statistics
    const exportRecords = async () => {
      await StatisticsUtils.exportRecords();
    };

    const searchDashboard = async () => {
      StatisticsUtils.subjectCounts();
      StatisticsUtils.customerSubdsidy();
      StatisticsUtils.customerCounts();
      StatisticsUtils.filterRecords();
    };

    //Scopes
    const selectedScopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
      set: (val) => store.commit("fomoStatisticsSearch/setSelectedScopes", val),
    });

    const scopesOptions = computed({
      get: () => store.state.fomoStatisticsSearch.scopesOptions,
    });
    watch(selectedScopes, () => {
      if (selectedScopes.value == null) {
        store.commit("fomoStatisticsSearch/setSelectedScopes", null);
      }
    });

    const mainCustomerSelect = ref(null);

    return {
      showTooltip,
      searchDashboard,
      customerOptionsOriginal,
      mainCustomerSelect,
      filterMainCustomerTags,
      mainCustomerOptions,
      selectedMainCustomer,
      scopesOptions,
      selectedScopes,
      tab,
      isStatisticLoading,
      filterCustomersTags,
      selectedCustomers,
      customerOptions,
      organisationsOptions,
      filterOrganisationsTags,
      selectedOrganisations,
      subjectsOptions,
      filterSubjectsTags,
      selectedSubjects,
      daysRangeModel,
      selectedYearsOptions,
      filterSelectedYears,
      selectedYears,
      resetDate,
      days,
      updateRange,
      filterCustomerFn(val, update) {
        update(async () => {
          if (val === "") {
            filterCustomersTags.value = [];
          } else {
            if (selectedMainCustomer.value != null)
              await FiltersService.getCustomersWithExcludeFilter(
                val,
                selectedMainCustomer.value.label
              );
            else {
              await FiltersService.getCustomersWithExcludeFilter(val, "");
            }
            const needle = val.toLowerCase();

            if (customerOptions.value != null)
              filterCustomersTags.value = customerOptions.value.filter(
                (v) => v.label && v.label !==null && v.label.toLowerCase().indexOf(needle) > -1
              );
          }
        });
      },
      filterMainCustomerFn(val, update) {
        update(async () => {
          if (val === "") {
            filterMainCustomerTags.value = [];
          } else {
            await FiltersService.getCustomersFilter(val);
            const needle = val.toLowerCase();

            filterMainCustomerTags.value = mainCustomerOptions.value.filter(
              (v) => v.label && v.label !==null && v.label.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
      filterOrganisationsFn(val, update) {
        update(() => {
          if (val === "") {
            filterOrganisationsTags.value = organisationsOptions.value;
          } else {
            const needle = val.toLowerCase();

            filterOrganisationsTags.value = organisationsOptions.value.filter(
              (v) => v.label && v.label !==null && v.label.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
      filterSubjectsFn(val, update) {
        update(() => {
          if (val === "") {
            filterSubjectsTags.value = subjectsOptions.value;
          } else {
            const needle = val.toLowerCase();

            filterSubjectsTags.value = subjectsOptions.value.filter(
              (v) => v.label && v.label !==null && v.label.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
      filterSelectedYearsFn(val, update) {
        update(() => {
          if (val === "") {
            filterSelectedYears.value = selectedYearsOptions.value;
          } else {
            const needle = val.toLowerCase();

            filterSelectedYears.value = selectedYearsOptions.value.filter(
              (v) => v.label && v.label !==null && v.label.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
      exportRecords,
    };
  },
};
</script>
